import { Component, Input } from '@angular/core';

import { ContainerComponent } from '../container/container.component';
import { PictureComponent } from '../picture/picture.component';
import { GlobalButtonComponent } from '../global-button/global-button.component';

export interface ImageTitle {
  containerSize?: string;
  background?: string;
  color: string;
  image: string;
  alt?: string;
  title: string;
  text: string[];
  cta?: {
    title: string;
    url: string;
    openInNewTab: boolean;
  }
}

@Component({
  selector: '[image-with-title]',
  imports: [ContainerComponent, PictureComponent, GlobalButtonComponent],
  templateUrl: './image-with-title.component.html',
  styleUrl: './image-with-title.component.scss',
  host: {
    '[style.backgroundColor]': 'data.background'
  }
})

export class ImageWithTitleComponent {
  @Input() data: ImageTitle = {
    background: '',
    color: '',
    image: '',
    alt: '',
    title: '',
    text: [''],
    cta: {
      title: '',
      url: '',
      openInNewTab: true,
    }
  }

  constructor() {}
}
